import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation.js";
import {
  BACK_ROW,
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_ROW,
  VALUE_FILL,
  hideColumnsAfter,
  setCell,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  addSheetTitle,
  addTableSpacer,
  applyBorderPattern,
  outerRowPatterns,
  setupPrinciple2DetailSheet,
  writeDataRow,
} from "./principle2DetailHelpers.js";
import {
  LINKED_FILL,
  formatNumber,
  getEnergyDetailRows,
  getFyLabels,
  safeText,
} from "./principle6SheetHelpers.js";

export const SHEET_NAME = "Energy consumed from NR";

const SHEET_TITLE = "Details of Energy consumed from non renewable";

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 9.1796875,
  E: 50.81640625,
  F: 30.54296875,
  G: 30.54296875,
  H: 30.26953125,
  I: 9.1796875,
  J: 9.1796875,
  K: 9.1796875,
  L: 9.1796875,
};

const TEMPLATE_ROW = 10;
const SPACER_ROW = 11;
const DATA_START_ROW = 12;
const COL_END = COL_H;

const HEADER_BORDERS = ["tttt", "tttt", "tttt", "tttt", "tttt"];
const TITLE_BORDERS = outerRowPatterns(COL_D, COL_END, {
  first: "tt--",
  middle: "t---",
  last: "t--t",
});
const SPACER_BORDERS = outerRowPatterns(COL_D, COL_END);

function safeDisplay(value, fallback = "") {
  if (value === null || value === undefined || value === "") return fallback;
  return String(value);
}

export function buildEnergyConsumedFromNRSheet(workbook, sectionC, reportingYear = "") {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });
  const { current: fyCurrent, previous: fyPrevious } = getFyLabels(reportingYear);
  const energy = sectionC?.principle6?.essentialIndicators?.energyConsumptionIntensity || {};

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd: COL_END,
    ySplit: 10,
    topLeftCell: "D12",
    hiddenCols: ["A", "B"],
  });
  hideColumnsAfter(ws, 11);

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_6, {
    row: BACK_ROW,
    col: COL_END,
    mergeEnd: COL_END,
    align: "right",
    parentCell: "D8",
  });

  addSheetTitle(ws, COL_END, SHEET_TITLE, { borderPatterns: TITLE_BORDERS });

  applyBorderPattern(ws, HEADER_ROW, COL_D, HEADER_BORDERS);
  ws.getRow(HEADER_ROW).height = 20.15;
  [
    { col: COL_D, label: "Sr. No." },
    { col: COL_E, label: "Name of other parameter" },
    { col: COL_F, label: "Unit" },
    { col: COL_G, label: fyCurrent },
    { col: COL_H, label: fyPrevious },
  ].forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      font: HEADER_FONT_11,
      bold: false,
      bordered: false,
      align: "center",
    });
  });

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, HEADER_BORDERS);
  for (let col = COL_D; col <= COL_END; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", {
      bordered: false,
      font: BODY_FONT,
      fill: col === COL_F ? LINKED_FILL : undefined,
    });
  }
  ws.getRow(TEMPLATE_ROW).hidden = true;

  addTableSpacer(ws, COL_D, COL_END, { row: SPACER_ROW, height: 30, patterns: SPACER_BORDERS });

  const detailRows = getEnergyDetailRows(energy, false);
  const dataRows = detailRows.length ? detailRows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(
      ws,
      row,
      COL_D,
      COL_END,
      [
        { col: COL_D, value: idx + 1, align: "center", fill: null, font: BODY_FONT },
        {
          col: COL_E,
          value: safeDisplay(item?.source),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_F,
          value: safeText(item?.unit),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_G,
          value: formatNumber(item?.current),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_H,
          value: formatNumber(item?.previous),
          align: "center",
          fill: VALUE_FILL,
        },
      ],
      { patterns: HEADER_BORDERS }
    );
  });

  return ws;
}
